import React, { useState, useEffect } from "react";
import { getOrdersReport } from "api/reports";
import { getLocalDate } from "utils/helpers";
import { connect } from 'react-redux';
import { Actions as appActions } from 'reducers/app';

import "./styles/analytics.css";

import moment from "moment";
import "moment/locale/ru";

import "./styles/custom.css";
import Select from "components/Select";
import StatusIcon from "./components/status";

interface IProps {
  toggleBlockUI: (block: boolean) => void;
}

const AnalayticsPage: React.FC<IProps> = ({ toggleBlockUI }) => {
  const [month, setMonth] = useState<number | undefined>(moment().month()+1);
  const [year, setYear] = useState<number | undefined>(moment().year());
  const [orders, setOrders] = useState<Array<any>>([]);
  const [shownOrder, switchShownOrder] = useState<boolean>(false);

  useEffect(() => {
    fetchOrders(dateFrom, dateTo);
  }, [month, year]);

  const yearList = [];

  const start = new Date("2017-01-01");
  const end = new Date(`${moment().format('YYYY-MM-DD')}`);
  const years = moment(end).diff(start, 'years');
  for(let i = 0; i < years; i++) {
    yearList.push(
      {
      id: start.getFullYear() + i,
      name: `${start.getFullYear() + i}`,
      }
    );
  };
  yearList.push(
    {
      id: moment().year(),
      name: `${moment().year()}`,
    }
  );

  const monthList = [
    { id: 1, name: moment.months(0) },
    { id: 2, name: moment.months(1) },
    { id: 3, name: moment.months(2) },
    { id: 4, name: moment.months(3) },
    { id: 5, name: moment.months(4) },
    { id: 6, name: moment.months(5) },
    { id: 7, name: moment.months(6) },
    { id: 8, name: moment.months(7) },
    { id: 9, name: moment.months(8) },
    { id: 10, name: moment.months(9) },
    { id: 11, name: moment.months(10) },
    { id: 12, name: moment.months(11) }
  ];

  let dateFrom = moment(`${month}/1/${year}`).startOf("month").format('YYYY-MM-DD');
  let dateTo = moment(`${month}/1/${year}`).endOf("month").add(1, 'day').format('YYYY-MM-DD');

  const formatter = new Intl.NumberFormat("ru", {minimumFractionDigits: 2})

  const onMonthChange = (value: number | undefined) => {
    setMonth(value);
  };

  const onYearChange = (value: number | undefined) => {
    setYear(value);
  };

  const fetchOrders = (dateFrom: string, dateTo: string) => {
    toggleBlockUI(true);
    getOrdersReport({ date_from: dateFrom, date_to: dateTo }).then(
      (response: any) => {
        if (response.success) {
          const newOrders = response.data.map((order: any) => {
            return {
              price_summ: order.products.reduce((prevValue: any, currentValue: any) => {
                  return (prevValue + ((currentValue.price_each * currentValue.quantity) - currentValue.discount));
                }, 0),
              fee_summ: order.products.reduce((prevValue: any, currentValue: any) => {
                  return prevValue + currentValue.agent_fee;
                }, 0),
              ...order
            };
          });
          setOrders(newOrders);
        } else {
          setOrders([]);
        }
        toggleBlockUI(false);
      }
    ).catch(e => toggleBlockUI(false));
	};

  return (
    <div className="container analaytics">
      <div className="row">
        <div className="col-12">
          <h2 className="title">Статистика продаж</h2>
        </div>
        <div className="col-12">
          <div className="shopcart___">
            <div className="cont card filter_____">
              <div className="row d-flex align-items-center justify-content-between">
                <div className="col-xl col-lg col-md col-6 stat_inpt pr-1">
                  <label>Год:</label>
                  <Select
                    value={year}
                    options={yearList}
                    onChange={onYearChange}
                  />
                </div>
                <div className="col-xl col-lg  col-md col-6 stat_inpt_moint pl-1">
                  <label>Месяц:</label>
                  <Select
                    value={month}
                    options={monthList}
                    onChange={onMonthChange}
                  />
                </div>
                <div className="col-xl col-lg col-md col-12 stat____ green_price">
                  <div className="text_discount green_text_ w__auto_ align-items-end">
                    <small>Вы заработали:</small>
                    <p className="mb-xl-0 grid_fontsize">
                      {formatter.format(
                          Math.round((orders.reduce((prevValue: any, currentValue: any) => {
                            return prevValue + (currentValue.status_id === 3 ? currentValue.fee_summ : 0);
                          }, 0)) * 100) / 100
                        )}{" "}
                    </p>
                  </div>
                  {/* <div className="atchivments__ top_g_____ text-center d-lg-none">
                    10 000<span> – мой бонус</span>
                  </div>
                  <div className="atchivments__ d-lg-none top_g_____ text-center">
                    10 000<span> – мой бонус</span>
                  </div> */}
                </div>
                {/* <div className="col-xl  col-lg col-md col-12  col-md stat____ green_price d-none d-lg-block">
                	<div className="atchivments__ top_g_____ text-center">
                    10 000<span> – мой бонус</span>
                  </div>
                  <div className="atchivments__ top_g_____ text-center">
                    10 000<span> – мой бонус</span>
                  </div>
                </div> */}
                <div className="col-xl-3 col-md  col-12   stat____ green_price black___">
                  <div className="text_discount green_price black___ w__auto_">
                    <small>Продаж за месяц:</small>
                    <p className="grid_fontsize">
                      {formatter.format(
                        Math.round((orders.reduce((prevValue: any, currentValue: any) => {
                          return prevValue + (currentValue.status_id === 3 ? currentValue.price_summ : 0);
                        }, 0)) * 100) / 100
                      )}
                      {" "}
                      ₽
                    </p>
                  </div>
                  {/* <div className="atchivments__ top_g_____ d-lg-none">
                    10 000<span> – мой бонус</span>
                  </div>
                  <div className="atchivments__ top_g_____ d-lg-none">
                    10 000<span> – мой бонус</span>
                  </div> */}
                </div>
                {/* <div className="d-none d-lg-block col-xl   col-12 col-md stat____ green_price black___">
                  <div className="atchivments__ top_g_____">10 000 <span>– мой бонус</span></div>
                  <div className="atchivments__ top_g_____">10 000 <span>– мой бонус</span></div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
				{orders.length !== 0 &&
					<div className="col-12"><h2 className="title">Сделки</h2></div>
				}
      </div>

      {orders.map(order => (
        <React.Fragment key={order.order_no}>
          <div className="grid_container">
            <p className="grid_head">Статус</p>
            <p className="grid_head_date">Дата</p>
            <p className="grid_head_fio hidden_767">Клиент</p>
            <p className="grid_head hidden_992">Кол-во товаров</p>
            <p className="grid_head hidden_992">Сумма скидки, ₽</p>
            <p className="grid_head shown_992 hidden_767">Скидка</p>
            <p className="grid_head_green">Бонус, Б</p>
            <p className="grid_head_summ hidden_767">Сумма, ₽</p>
            <div
              className="grid_order_container"
              onClick={() => switchShownOrder(shownOrder === order.order_no ? undefined : order.order_no)}
            >
              <div className="grid_order_status">
                <StatusIcon status={order.status_id} />
              </div>
              <p className="grid_order_info_date">
                {order.date_status_change ? getLocalDate(order.date_status_change, "DD.MM.YYYY") : ""}
              </p>
              <p className="grid_order_info_fio">
                {order.client_fio}
              </p>
              <p className="d-md-none grid_order_info_767 hidden_992">Кол-во товаров, шт:</p>
              <p className="grid_order_info hidden_992 bold_font">
                {order.products.reduce((prevValue: any, currentValue: any) => {
                  return prevValue + currentValue.quantity;
                }, 0)}
              </p>
              <p className="d-md-none grid_order_info_767">Сумма скидки, ₽:</p>
              <p className="grid_order_info bold_font">
                {formatter.format(
                  Math.round((order.products.reduce((prevValue: any, currentValue: any) => {
                    return prevValue + currentValue.discount;
                  }, 0)) * 100) / 100
                )}
              </p>
              <p className="d-md-none grid_order_info_green_767">Бонус, Б:</p>
              <p className="grid_order_info_green bold_font">
                {formatter.format(
                  Math.round((order.products.reduce((prevValue: any, currentValue: any) => {
                    return prevValue + currentValue.agent_fee;
                  }, 0)) * 100) / 100
                )}
              </p>
              <p className="d-md-none grid_order_info_767">Сумма, ₽:</p>
              <p className="grid_order_info_summ bold_font">
                {formatter.format(Math.round((order.price_summ) * 100) / 100)}
              </p>

              {shownOrder === order.order_no && (
                <React.Fragment>
                  <div className="divider"></div>

                  {order.products.map((product: any, index: number) => (
                    <div key={`${index}${product.product_id}`} className="grid_product_container">
                      <div className="grid_product_status hidden_767 shown_575">
                        <img src={product.image} alt="img" className="prod_img"/>
                      </div>
                      <p className="grid_product_info_name">
                        {product.product_name}
                      </p>
                      <p className="d-lg-none grid_product_info_992">Цена, ₽:</p>
                      {' '}
                      <p className="grid_product_info bold_font">
                        {formatter.format(product.price_each)}
                      </p>
                      <p className="grid_product_info hidden_992 hidden_767 bold_font">
                        {product.class_name !== "Без класса" && <span className="grey">Класс:</span>}
                        {" "}
                        {product.class_name === "Без класса" ? '' : product.class_name}
                      </p>
                      <p className="d-lg-none grid_product_info_992">Кол-во, шт:</p>
                      <p className="grid_product_info bold_font">
                        {product.quantity}
                      </p>
                      <p className="d-lg-none grid_product_info_992">Сумма скидки, ₽</p>
                      {" "}
                      <p className="grid_product_info bold_font">
                        {formatter.format(
                          Math.round((product.discount) * 100) / 100
                        )}
                      </p>
                      <p className="d-lg-none grid_product_info_green_992 grid_order_info_green_767 grid_product_info_green_500">Бонус, Б</p>
                      {" "}
                      <p className="grid_product_info_green bold_font">
                        {formatter.format(
                          Math.round((product.agent_fee) * 100) / 100
                        )}
                      </p>
                      <p className="d-lg-none grid_product_info__summ_992">Сумма, ₽</p>
                      {" "}
                      <p className="grid_product_info_summ bold_font">
                        {formatter.format(
                          Math.round(
                            (product.quantity * product.price_each - product.discount) * 100) / 100
                        )}
                      </p>
                    </div>
                  ))}
                </React.Fragment>
              )}
            </div>
          </div>
        </React.Fragment>
      ))}
    </div>
  );
};

const actions = {
  toggleBlockUI: appActions.toggleUIBlocking,
};

export default connect(null, actions)(AnalayticsPage);
